export default function PlayedList({ played }) {
  if (!played?.length) {
    return <p className="text-sm text-peak-muted">Nothing played yet tonight.</p>
  }

  // Dedupe consecutive entries (the recently-played backfill can produce dupes)
  const seen = new Set()
  const unique = []
  for (const p of played) {
    const key = p.spotify_track_id || `${p.song_title}|${p.artist}`.toLowerCase()
    if (seen.has(key)) continue
    seen.add(key)
    unique.push(p)
  }

  return (
    <ul className="space-y-1">
      {unique.slice(0, 25).map((p) => (
        <li
          key={p.id}
          className="flex items-center gap-3 px-3 py-2 rounded-lg bg-peak-surface/40 line-through opacity-60"
        >
          <span className="flex-1 truncate text-sm">
            {p.song_title} <span className="text-peak-muted">— {p.artist}</span>
          </span>
        </li>
      ))}
    </ul>
  )
}
